import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);

axios.defaults.timeout = 10000;

// 请求拦截器
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data;
    // skipErrorToast：页面用弹框自行提示错误时，跳过全局 toast
    if (
      res.code != 0 &&
      response.config.url.indexOf("engine.ycckkj.cn") == -1 &&
      !response.config.skipErrorToast
    ) {
      Toast(res.resp_msg);
    }
    return response;
  },
  error => {
    if (error && error.stack.indexOf("timeout") > -1) {
      Toast("请求超时,请刷新页面");
    }
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, headers).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js